import { ReactNode } from 'react';
import { Title } from '../utils/style';

interface IProps {
  children: ReactNode;
}

const PageTitle = ({ children }: IProps) => {
  return <Title data-testid="heading--primary">{children}</Title>;
};

export default PageTitle;
